import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import { usePermission } from 'admin/hocs'
import { useHasFeatureFunc } from 'utils/useHasFeature'
import { UnderlineNavigationTabs } from 'uiComponents/navigation/underlineNavigationTabs'
import InSectionTabsSlot from 'uiComponents/navigation/sectionTabsSlot'

/**
 * Section navigation for the Discounts area, shared between the pools/codes
 * pages and the discount rules pages, which render in separate containers.
 */
function DiscountsSectionTabs() {
    const { accountSlug } = useParams<BaseRouteParams>()
    const location = useLocation()
    const history = useHistory()
    const { hasPermission } = usePermission()
    const hasFeature = useHasFeatureFunc()

    const base = `/account/${accountSlug}/discounts`
    const sections = [
        { name: 'Pools', path: `${base}/pools`, activeKey: '/discounts/pools', shouldShow: true },
        { name: 'Codes', path: `${base}/codes`, activeKey: '/discounts/codes', shouldShow: true },
        {
            name: 'Discount Rules',
            path: `${base}/rules/home`,
            activeKey: '/discounts/rules',
            shouldShow: hasPermission('partner_admin', accountSlug) && hasFeature('DiscountRulesPage'),
        },
    ].filter((section) => section.shouldShow)

    return (
        <InSectionTabsSlot>
            <UnderlineNavigationTabs
                tabs={sections.map((section) => ({
                    name: section.name,
                    current: location.pathname.includes(section.activeKey),
                    href: section.path,
                    onClick: () => history.push(section.path),
                }))}
            />
        </InSectionTabsSlot>
    )
}

export default DiscountsSectionTabs
